<div class="render-limit-selector" [ngClass]="{'isMobile': isMobile}">
  <div *ngIf="isRenderLimitTitleShown" class="billing-protection-header">
    <span class="billing-protection-title">Billing Protection</span>
    <span class="billing-protection-subtitle">Uploads Per Period</span>
  </div>
  <div class="render-limit-options" [class.maxRowElements5]="inputMaxElementsInRow === 5" [class.maxRowElements4]="inputMaxElementsInRow === 4">
    <button
      *ngFor="let limit of renderLimitOptions"
      [class.selected]="isSelected(limit)"
      [class.no-limit-option]="limit === 9999"
      [disabled]="limit !== 0 && limit <= firebaseAuth.currentUser?.renderModelsPerCycle"
      (click)="setRenderLimit(limit)"
    >
      {{ limit === 9999 ? 'Don`t Notify' : limit }}
    </button>
  </div>
  <div class="tooltip" *ngIf="currentTooltip" [@tooltip]>{{ currentTooltip }}</div>
</div>
